// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-update-resource-metadata-recipient_id.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm($id: uuid!, $recipient_id: uuid!) {
  update_tasks_resources_by_pk(
    pk_columns: { id: $id }
    _append: { metadata: { recipient_id: $recipient_id } }
  ) {
    id
    metadata
  }
}

`